import { styled as r, Typography as i } from "@mui/material";
import a from "./ApeironBlueButton.js";
import { COOKIE_NAME as l, COOKIE_EXPIRES as m } from "../../../constants/consent.js";
import { useRef as d, useCallback as f } from "react";
import u from "react-cookie-consent";
import { useTranslation as g } from "react-i18next";
import { jsxs as h, jsx as e } from "react/jsx-runtime";
const x = r(i)`
  font-size: 20px;
  font-weight: 300;
  line-height: 24px;
  margin-bottom: 8px;
`, b = r(i)`
  font-size: 12px;
  line-height: 16px;
`, C = r(a)`
  --background-color: #f1b535;
  border-radius: 6px;
  color: black;
  height: unset;
  font-weight: 400;
  padding: 10px 25px;
`, B = (c) => {
  const {
    onAccept: t,
    onDecline: s
  } = c, o = d(null), {
    t: n
  } = g(), p = f(() => {
    o.current && o.current.accept(), t && t();
  }, [t]);
  return /* @__PURE__ */ h(u, {
    buttonText: /* @__PURE__ */ e(C, {
      component: "div",
      onClick: p,
      children: n("common.accept")
    }),
    cookieName: l,
    expires: m,
    ref: o,
    location: "bottom",
    buttonStyle: {
      backgroundColor: "unset",
      padding: 0,
      margin: 0
    },
    contentStyle: {
      margin: 0
    },
    style: {
      alignItems: "center",
      left: "50%",
      transform: "translateX(-50%)",
      gap: 10,
      padding: 15,
      maxWidth: 1024
    },
    onAccept: t,
    onDecline: s,
    children: [/* @__PURE__ */ e(x, {
      children: n("consent.title")
    }), /* @__PURE__ */ e(b, {
      children: n("consent.usage")
    })]
  });
};
export {
  B as default
};
//# sourceMappingURL=ApeironCookieConsent.js.map
